import React from 'react';
import './YouTubeBanner.css';

/**
 * YouTubeBanner Component
 * A compact banner linking to YouTube channel
 * Shows "How LockItUp Software Works" with play icon
 */
function YouTubeBanner() {
  return (
    <section className="youtube-banner-section">
      <div className="container">
        <a 
          href="https://www.youtube.com/@lockitup-r5l" 
          target="_blank" 
          rel="noopener noreferrer"
          className="youtube-banner"
        >
          {/* YouTube Play Icon */}
          <div className="youtube-icon">
            <svg 
              width="48" 
              height="48" 
              viewBox="0 0 48 48" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="24" cy="24" r="23" fill="#FF0000" stroke="#FF0000" strokeWidth="2"/>
              <path d="M19 15L35 24L19 33V15Z" fill="white"/>
            </svg>
          </div>

          {/* Banner Text */}
          <div className="youtube-text">
            <h3 className="youtube-title">How LockItUp Software Works</h3>
            <p className="youtube-subtitle">Watch on YouTube</p>
          </div>

          {/* Arrow Icon */}
          <div className="youtube-arrow">
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M5 12H19M19 12L12 5M19 12L12 19" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </a>
      </div>
    </section>
  );
}

export default YouTubeBanner;
